import { render, staticRenderFns } from "./transcription.vue?vue&type=template&id=05ce795c&lang=pug&"
import script from "./transcription.vue?vue&type=script&lang=ts&"
export * from "./transcription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports